module.exports = {
  addBeneComponentEvents: {
    AddChildSIN: {
      code: 'SIN',
      events: {
        SIN: {
          description: 'Triggered when the child SIN is submitted',
          eventHub: {
            action: 'SIN',
            dataKeys: []
          },
          ga: {
            action: 'Submit SIN'
          }
        }
      }
    },
    AddChildReview: {
      code: 'Review',
      events: {
        Review: {
          description: 'Triggered when user clicks continue from child review screen',
          eventHub: {
            action: 'Review',
            dataKeys: []
          },
          ga: {
            action: 'Submit Review'
          }
        },
        Somethingwentwrong: {
          description: 'Triggered when user clicks continue from child review screen and add bene fails',
          eventHub: {
            action: 'Somethingwentwrong',
            dataKeys: []
          },
          ga: {
            action: 'Error'
          }
        }
      }
    },
    AddChildSuccess: {
      code: '',
      events: {
        Success: {
          description: 'Triggered when user lands on success screen',
          eventHub: {
            code: 'Success',
            action: 'Success',
            dataKeys: []
          },
          ga: {
            action: 'Add Bene Success'
          }
        },
        Done: {
          description: 'Triggered when user clicks on Done button on success screen',
          eventHub: {
            code: 'Done',
            action: 'Done',
            dataKeys: []
          },
          ga: {
            action: 'Go To Dashboard'
          }
        },
        Contribute: {
          description: 'Triggered when user clicks on Contribute button on success screen',
          eventHub: {
            code: 'Contribute',
            action: 'Contribute',
            dataKeys: []
          },
          ga: {
            action: 'Go To Contribute'
          }
        }
      }
    },
    RedirectErrorDialog: {
      code: 'Error',
      events: {
        ErrorIndvPlan: {
          description: 'Triggered when user lands on error screen for individual plan',
          eventHub: {
            code: 'IndvPlan',
            action: 'ErrorIndvPlan',
            dataKeys: []
          },
          ga: {
            action: 'Individual Plan Error'
          }
        },
        Error5thBene: {
          description: 'Triggered when user lands on error screen for 5th bene',
          eventHub: {
            code: '5thBene',
            action: 'Error5thBene',
            dataKeys: []
          },
          ga: {
            action: '5th Bene Error'
          }
        }
      }
    }
  }
};
